import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Sun, Moon, Monitor, Check } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

export default function ThemeToggle() {
  const { theme, effectiveTheme, setTheme } = useTheme();

  const themeOptions = [
    { value: 'light' as const, label: 'Light', icon: Sun },
    { value: 'dark' as const, label: 'Dark', icon: Moon },
    { value: 'system' as const, label: 'System', icon: Monitor },
  ];

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          className="p-2.5 rounded-lg text-zinc-700 dark:text-zinc-300 hover:bg-zinc-100 dark:hover:bg-zinc-700 transition-colors"
          aria-label="Toggle theme"
          data-testid="theme-toggle"
        >
          {effectiveTheme === 'dark' ? <Moon size={20} /> : <Sun size={20} />}
          <span className="sr-only">Toggle theme</span>
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="min-w-[160px] bg-white dark:bg-zinc-800 rounded-lg shadow-lg border border-zinc-200 dark:border-zinc-700 p-1 z-50"
          sideOffset={5}
          align="end"
        >
          {themeOptions.map((option) => {
            const Icon = option.icon;
            const isSelected = theme === option.value;

            return (
              <DropdownMenu.Item
                key={option.value}
                onClick={() => setTheme(option.value)}
                data-testid={`theme-option-${option.value}`}
                className={`flex items-center gap-3 px-3 py-2 text-sm rounded cursor-pointer outline-hidden
                           ${isSelected ? 'text-sky-600 dark:text-sky-400' : 'text-zinc-900 dark:text-zinc-100'}
                           hover:bg-zinc-100 dark:hover:bg-zinc-700
                           focus:bg-zinc-100 dark:focus:bg-zinc-700`}
              >
                <Icon size={16} />
                <span className="flex-1">{option.label}</span>
                {isSelected && <Check size={16} />}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
